import { render } from "./Magnifier.vue?vue&type=template&id=504d4c88"
const script = {}
script.render = render

export default script